import { Typography } from '@guildeducationinc/recess';
import React from 'react';
import styles from './ResultCount.module.scss';

interface Props {
	count: number;
	query: string;
}
export const ResultCount: React.FC<Props> = ({ count, query }) => {
	return (
		<div
			aria-live='polite'
			className={
				query
					? styles.activeSearchResultsLabelContainer
					: styles.noActiveSearchResultsLabelContainer
			}
		>
			<Typography data-testid='search-results-number' variant='label2'>
				<span className='weglot-exclude'>{count}</span> {count === 1 ? 'school' : 'schools'}
			</Typography>
			<Typography
				aria-hidden={!query}
				className={query ? styles.activeSearchResultsLabel : styles.noActiveSearchResultsLabel}
				data-testid='search-results-label'
				variant='label2'
			>
				{' '}
				for &ldquo;{query}&rdquo;
			</Typography>
		</div>
	);
};
